import { N30, N800 } from '@atlaskit/theme/colors';
import React from 'react';
import styled from 'styled-components';

export type JoinLinkItemProps = {
  readonly linkLabel: JSX.Element;
  readonly onLinkClick: () => void;
};

export function JoinLinkItem({
  linkLabel,
  onLinkClick
}: JoinLinkItemProps): JSX.Element {
  return (
    <RootContainer>
      <div onClick={onLinkClick}>{linkLabel}</div>
    </RootContainer>
  );
}

const RootContainer = styled.div`
  font-size: 12px;
  line-height: 15px;
  padding: 8px 16px 8px 16px;
  color: ${N800};
  &:hover {
    background-color: ${N30};
    cursor: pointer;
  }
`;
